import styled from 'styled-components';

import { ActionMenu } from 'ui/actionMenu';
import { ActionMenuOption, AllowedActionMenuElements, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { SecondaryButton } from 'ui/button';
import { Overflow } from 'ui/icons/navigation/Overflow';
import { Delete16 } from 'ui/icons/aurora/16px/Delete16';
import { Edit16 } from 'ui/icons/action/Edit16';
import { MoveToFolder } from 'ui/icons/action/MoveToFolder';
import { colors, spacing } from 'ui/theme';
import { useSelectionContext } from 'modules/creativeLibrary/contexts/SelectionContext';
import { useCreativeLibraryFolderModals } from 'modules/creativeLibrary/hooks/useCreativeLibraryModals';
import { AssetSubfolder } from 'modules/creativeLibrary/types';

type Props = { folder: AssetSubfolder };

const StyledButton = styled(SecondaryButton)`
  padding: 0 ${spacing.half};
`;

export const displayContent = {
  delete: 'Delete folder',
  move: 'Move to folder',
  new: 'New subfolder',
  rename: 'Rename folder',
};

export const FolderActionMenu = ({ folder }: Props) => {
  const { selectItem } = useSelectionContext();
  const modals = useCreativeLibraryFolderModals();

  const options: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <MoveToFolder color={colors.grey50} height={16} width={16} />
          <span>{displayContent.move}</span>
        </>
      ),
      id: 'move-to-folder',
      onClick: () => {
        selectItem(folder);
        modals.move.toggle(true);
      },
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <Edit16 />
          <span>{displayContent.rename}</span>
        </>
      ),
      id: 'rename-folder',
      onClick: () => {
        selectItem(folder);
        modals.rename.toggle(true);
      },
    },
    {
      as: AllowedActionMenuElements.Button,
      isDestructive: true,
      content: (
        <>
          <Delete16 />
          <span>{displayContent.delete}</span>
        </>
      ),
      id: 'delete-folder',
      onClick: () => {
        selectItem(folder);
        modals.delete.toggle(true);
      },
    },
  ];
  return (
    <ActionMenu align={MENU_ALIGNMENTS.RIGHT} id={`action-menu-${folder.id}`} options={options}>
      <StyledButton>
        <Overflow color={colors.grey90} />
      </StyledButton>
    </ActionMenu>
  );
};
